<style lang="scss">
	.cz-dp{
		position: absolute;
		top: 5px;
		right: 60px;
		width: 120px;
		height: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
		/*background: #eee;*/
		border: 1px solid #ddd;
		border-radius: 10px;
		.icon-text{
			position: absolute;
			right: -5px;
			top: -5px;
			padding: 5px 8px;
			background: #FF7368;
			color: #fff;
			border-radius: 15px 15px 15px 0;
			font-style: normal;
			font-size: 12px;
		}
		.cz-con{
			display: inline-block;
			text-align: center;
			margin-top: -10px;
		}
		.info{
			margin-bottom: 8px;
			color: #000;
		}
		.money{
			margin-bottom: 7px;
			.bold{
				font-size: 18px;
				font-weight: bold;
				color: #b17e47;
			}
			.original{
				font-size: 12px;
				color: #9B988D;
				margin-left: 5px;
			}
		}
		.next{
			font-size: 11px;
		}
		.gold{
			font-size: 14px;
			margin-bottom: 10px;
			color: #21201D;
		}
		.describe{
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 20px;
			line-height: 20px;
			text-align: center;
			background: #f2e1bc;
			border-radius: 0 0 10px 10px;
			font-size: 12px;
		}
	}
</style>
<template>
	<div>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="" prop="appid">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId" :clear="'noclear'"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item>
						<el-button type="success" v-has="menuPage == 'agent' ? 'agentRechargeConfig:add' : 'rechargeConfig:add'" icon="el-icon-circle-plus-outline"  @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
					<el-table-column prop="orderNo" label="排序" width="60">
					</el-table-column>
					<!--<el-table-column prop="" label="序号" width="60">-->
						<!--<template slot-scope="scope">-->
							<!--<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>-->
						<!--</template>-->
					<!--</el-table-column>-->
					<el-table-column label="充值类型" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.rechargeType == 0">看点</span>
							<span v-if="scope.row.rechargeType == 1">普通会员</span>
							<span v-if="scope.row.rechargeType == 2">连续续费会员</span>
						</template>
					</el-table-column>
					<el-table-column prop="rechargeInfo" label="充值说明"></el-table-column>
					<el-table-column  label="会员单次时间">
						<template slot-scope="scope">
							<div v-if="scope.row.rechargeType == 1">{{scope.row.days}}天</div>
							<div v-if="scope.row.rechargeType == 2">{{scope.row.signingType == 1 ? '1个月' : '1个季度'}}</div>
						</template>
					</el-table-column>
                    <el-table-column prop="money" label="充值金额" v-if="platform == 'dy-dp'"></el-table-column>
					<el-table-column prop="money" label="首月充值金额" v-if="platform == 'wb-dp'"></el-table-column>
					<el-table-column prop="nextMonthPric" label="次月充值金额" v-if="platform == 'wb-dp'"></el-table-column>
					<el-table-column prop="originalPrice" label="划线价"></el-table-column>
					<!--<el-table-column prop="rechargeInfo" label="增点数"></el-table-column>-->
					<!--<el-table-column prop="subscript" label="角标"></el-table-column>-->
					<el-table-column label="展示角标">
						<template slot-scope="scope">
							<div>
								<span class="succes-text" v-if="scope.row.isShowSubscript == 1">已展示：{{scope.row.subscript}}</span>
								<span class="danger-text"  v-if="scope.row.isShowSubscript == 0">未展示</span>
							</div>
						</template>
					</el-table-column>
					<!--<el-table-column label="默认选中">-->
						<!--<template slot-scope="scope">-->
							<!--<span v-if="scope.row.selected == 0">否</span>-->
							<!--<span v-if="scope.row.selected == 1">是</span>-->
						<!--</template>-->
					<!--</el-table-column>-->
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row.id)">详情</el-button>
							<el-button type="primary" v-has="menuPage == 'agent' ? 'agentRechargeConfig:update' : 'rechargeConfig:update'" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover v-has="menuPage == 'agent' ? 'agentRechargeConfig:delete' : 'rechargeConfig:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<!-- :disabled="scope.row.isShow == 1 ? true : false" -->
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
							<!--<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>

		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td width="200">充值类型</td>
					<td>
						<span v-if="ruleForm.rechargeType == 0">看点</span>
						<span v-if="ruleForm.rechargeType == 1">普通会员</span>
						<span v-if="ruleForm.rechargeType == 2">连续续费会员</span>
					</td>
				</tr>
				<tr>
					<td>充值金额</td>
					<td>
						<p>实付金额：{{ruleForm.money}}</p>
						<p>划线价：{{ruleForm.originalPrice}}</p>
					</td>
				</tr>
				<tr>
					<td>总金币数量</td>
					<td>
						<!-- <p>{{ruleForm.money * 100 + ruleForm.present}}</p> -->
						<p>{{ruleForm.rechargeType == 0?ruleForm.money * 100 + ruleForm.present:0}}</p>
					</td>
				</tr>
				<tr>
					<td>充值说明</td>
					<td>
						<p>{{ruleForm.rechargeInfo}}</p>
					</td>
				</tr>
				<tr>
					<td>档位描述</td>
					<td>
						{{ruleForm.templateInfo}}
					</td>
				</tr>
				<tr>
					<td>展示角标</td>
					<td>
						<!--<el-switch-->
						<!--v-model="ruleForm.isShowSubscript"-->
						<!--active-color="#13ce66" disabled-->
						<!--inactive-color="#ff4949" :active-value="1"-->
						<!--:inactive-value="0">-->
						<!--</el-switch>-->
						<span class="succes-text" v-if="ruleForm.isShowSubscript == 1">已展示：{{ruleForm.subscript}}</span>
						<span class="danger-text"  v-if="ruleForm.isShowSubscript == 0">未展示</span>
					</td>
				</tr>
				<!-- <tr>
					<td>排序</td>
					<td>
						{{ruleForm.orderNo}}
					</td>
				</tr>
				<tr>
					<td>是否展示</td>
					<td>
						<el-switch
								v-model="ruleForm.isShow"
								active-color="#13ce66" disabled
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0">
						</el-switch>
					</td>
				</tr> -->
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--添加-->
		<!--新建编辑-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="800px">
			<div style="position: relative;">
				<div class="cz-look cz-dp">
					<i class="icon-text" v-if="ruleForm.subscript && ruleForm.isShowSubscript == 1" :style="'background:' + ruleForm.subscriptColour">{{ruleForm.subscript}}</i>
					<div class="cz-con">
						<p class="info" v-if="ruleForm.rechargeInfo"><span>{{ruleForm.rechargeInfo}}</span></p>
						<p class="money" v-if="ruleForm.money"><span class="bold">￥{{ruleForm.money}}</span><del class="original">{{ruleForm.originalPrice}}</del></p>
						<p class="next" v-if="ruleForm.rechargeType == 2">次月￥{{ruleForm.nextMonthPric}}续费<br/>可随时取消</p>
						<p class="describe" v-if="ruleForm.templateInfo">{{ruleForm.templateInfo}}</p>
					</div>
				</div>
				<el-form :rules="rules" ref="ruleForm" :model="ruleForm" size="small" label-width="150px" class="input320" style="max-height: 480px;overflow: auto; padding-right: 20px;">
					<el-form-item label="排序：" clearable prop="orderNo">
						<el-input type="number" v-model="ruleForm.orderNo" placeholder="请输入排序数字" clearable></el-input>
					</el-form-item>
					<el-form-item label="类型：" clearable prop="rechargeType">
						<el-select v-model="ruleForm.rechargeType"  placeholder="选择充值类型" @change="changeType" style="width: 320px">
							<el-option
									v-for="item in optionsRechargeType"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<div v-if="ruleForm.rechargeType == 1">
						<el-form-item label="金额：" clearable prop="money">
							<el-input v-model="ruleForm.money" type="number" clearable=""  placeholder="请输入金额"></el-input>
						</el-form-item>
					</div>
					<div v-if="ruleForm.rechargeType == 2">
						<el-form-item label="模板信息：" clearable prop="rechargeProject" v-if="ruleForm.rechargeType == 2">
							<el-select v-model="ruleForm.signingTemplateId"  placeholder="请选择模板" value-key="sinaTemplateDetail" @change="changeSignType" style="width: 320px;">
								<el-option
										v-for="item in optionsSignType"
										:key="item.sinaSigningTemplateId"
										:label="item.sinaTemplateDetail"
										:value="item.sinaSigningTemplateId">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="首月金额：" clearable prop="money">
							<el-input v-model="ruleForm.money" type="number" disabled="disabled" clearable></el-input>
						</el-form-item>
						<el-form-item label="次月金额：" clearable prop="nextMonthPric">
							<el-input v-model="ruleForm.nextMonthPric" type="number" disabled="disabled" clearable></el-input>
						</el-form-item>
					</div>
					<el-form-item label="划线价：" clearable prop="originalPrice">
						<el-input v-model="ruleForm.originalPrice" type="number" clearable placeholder="请输入划线价"></el-input>
					</el-form-item>
					<el-form-item label="充值说明：" clearable prop="rechargeInfo">
						<el-input v-model="ruleForm.rechargeInfo" :disabled="ruleForm.rechargeType == 2 ? true : false" clearable placeholder="请输入充值说明"></el-input>
					</el-form-item>
					<el-form-item label="档位描述：" prop="templateInfo">
						<el-input v-model="ruleForm.templateInfo" placeholder="请输入XX元/天"></el-input>
						<p class="input-note">建议：XX元/天</p>
					</el-form-item>
					<el-form-item label="时间：" clearable prop="days" v-if="ruleForm.rechargeType == 1">
						<el-input type="number" v-model="ruleForm.days" clearable style="width: 100px;margin-right:10px;" placeholder="请输入数字"></el-input>天
					</el-form-item>
					<el-form-item label="展示角标：">
						<el-switch
								v-model="ruleForm.isShowSubscript"
								active-color="#13ce66"
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0">
						</el-switch>
					</el-form-item>
					<el-form-item label="角标文案：">
						<el-input placeholder="请输入角标文案,最多只能输入5字" maxlength='5' v-model="ruleForm.subscript" clearable="" >
						</el-input>
					</el-form-item>
					<!--<el-form-item label="是否默认选中：" prop="SELECTED" class="el-form-item&#45;&#45;small">-->
						<!--<el-radio-group v-model="ruleForm.selected">-->
							<!--<el-radio :label="0">否</el-radio>-->
							<!--<el-radio :label="1">是</el-radio>-->
						<!--</el-radio-group>-->
					<!--</el-form-item>-->
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
    // import AppList from '@/components/AppList'
    import {list, add, del, details, listSign, detailsSign} from "@/api/wb/app/recharge";
    export default {
        name:'DpRechargeGear',
        props:['menuPage'],
        data() {
            // var validateNum = (rule, value, callback) => {
            // 	if (!(/(^[1-9]\d*$)/.test(value))) {
            // 		return callback(new Error('数字应为正整数'));
            // 	} else {
            // 		callback();
            // 	}
            // };
            return {
                platform: localStorage.getItem('platform'),
                formInline: {
                    appId: localStorage.getItem('appId')
                },
                dialogTitle: '添加充值档位',
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                currentPage: 1,
                dialogFormVisible: false,
                // ruleForm: {},
                dialogInfoVisible: false,
                optionsRechargeType: [
                    {
                        value: 1,
                        label: '普通会员'
                    },
                    {
                        value: 2,
                        label: '连续订阅会员'
                    }
                    // {
                    //     value: 0,
                    //     label: '金币'
                    // }
                ],
                optionsSignType: [],
                ruleForm: {
                    appId: localStorage.getItem('appId'),
                    bookId: '',
                    change:'add',
                    durationType: 3,
                    days: '',
                    id:'',
                    isShow:1,
                    isShowHighLight:0,
                    isShowSubscript:0,
                    money:'',
                    nextMonthPric: '',
                    orderNo: '',
                    originalPrice:'',
                    present:'',
                    rechargeInfo:'',
                    rechargeType:'',
                    selected: 0,
                    signingTemplateId: '',
                    signingType: '',
                    subscript:'',
                    subscriptColour:'#FF4640',
                    templateInfo:'',
                },
                rules: {
                    rechargeType: [
                        {required: true, message: '请选择充值类型', trigger: 'change'}
                    ],
                    money: [
                        {required: true, message: '请输入实付金额', trigger: 'blur'},
                        // { validator: validateNum, trigger: 'blur' }
                    ],
                    originalPrice: [
                        {required: true, message: '请输入划线价', trigger: 'blur'},
					],
                    rechargeInfo: [
                        {required: true, message: '请输入充值说明', trigger: 'change'}
                    ],
                    // templateInfo: [
                    //     {required: true, message: '请输入档位描述', trigger: 'change'}
                    // ],
                    orderNo: [
                        {required: true, message: '请输入排序', trigger: 'blur'},
                        // { validator: validateNum, trigger: 'blur' }
                    ],
                    subscript:[
                        {required: true, message: '请输入角标文案', trigger: 'blur'},
                    ],
                    days:[
                        {required: true, message: '请输入时间', trigger: 'blur'},
                    ]
                }
            }
        },
        computed: {},
        watch: {
        },
        mounted: function() {
            this.getOptionsRechargeType()
            this.getTableData()
			this.getSinaTemplateList()
        },
        methods: {
            getOptionsRechargeType() {
                if (localStorage.getItem('platform') == 'wb-dp') {
                    this.optionsRechargeType = [
                        {
                            value: 1,
                            label: '普通会员'
                        },
                        {
                            value: 2,
                            label: '连续订阅会员'
                        }
                        // {
                        //     value: 0,
                        //     label: '金币'
                        // }
                    ]
				} else {
                    this.optionsRechargeType = [
                        {
                            value: 1,
                            label: '普通会员'
                        }
                        // {
                        //     value: 0,
                        //     label: '金币'
                        // }
                    ]
				}
			},
            // 从组件获取appid
            getAppId(data) {
                this.formInline.appId = data
                this.getTableData()
            },
            // 分页
            handleCurrentChange(value) {
                this.currentPage = value
                this.getTableData()
            },
            // pageSize切换
            handleSizeChange (val) {
                this.tableData.pageSize  = val
                this.currentPage = 1
                this.getTableData()
            },
            handleLook(id) {
                // this.ruleForm = row
                this.dialogInfoVisible = true
                this.getDetails(id)
            },
            // 编辑
            handleEdit(id) {
                this.dialogTitle = '编辑充值档位'
                this.dialogFormVisible = true
                this.getDetails(id)

            },
            getDetails(id) {
                details({
                    id: id
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.ruleForm = response.data.content
                        this.ruleForm.change = 'upd'
						this.ruleForm.appId = localStorage.getItem('appId')
						this.ruleForm.durationType = 3
						this.ruleForm.bookId = response.data.content.bookId ? response.data.content.bookId : ''
                        if (this.$refs['ruleForm'] !== undefined) {
                            this.$refs['ruleForm'].resetFields()
                        }
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
            addData() {
                // const appName = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)[0].name
                this.ruleForm = {
                    appId: localStorage.getItem('appId'),
                    bookId: '',
                    change:'add',
                    durationType: 3,
					days: '',
                    id:'',
                    isShow:1,
                    isShowHighLight:0,
                    isShowSubscript:0,
                    money:'',
                    nextMonthPrice: '',
                    orderNo: '',
                    originalPrice:'',
                    present:'',
                    rechargeInfo:'',
                    rechargeType:'',
                    selected: 0,
                    signingTemplateId: '',
                    signingType: '',
                    subscript:'',
                    subscriptColour:'#FF4640',
                    templateInfo:'',
                }
                this.dialogFormVisible = true
                this.dialogTitle = '添加充值档位'


                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
            },
            // 弹框确定
            editDialogSureBtn (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveTableData('add')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleDelete(id) {
                del({
                    id: id,
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        if (this.tableData.result.length === 1 && this.currentPage > 1) {
                            this.currentPage =  this.currentPage - 1
                        }
                        this.$refs[id].doClose()
                        this.getTableData()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })
            },
            // 保存编辑信息
            saveTableData () {
                console.log(this.ruleForm)
                // const info = {
                //     appId:this.formInline.appId|| '',
                //     change:this.ruleForm.change,
                //     durationType:this.ruleForm.durationType,
                //     id:this.ruleForm.id || '',
                //     isShow:this.ruleForm.isShow,
                //     isShowHighLight:this.ruleForm.isShowHighLight,
                //     isShowSubscript:this.ruleForm.isShowSubscript,
                //     money:this.ruleForm.money || '',
                //     orderNo:this.ruleForm.orderNo || '',
                //     originalPrice:this.ruleForm.originalPrice || '',
                //     present:this.ruleForm.present || '',
                //     rechargeInfo:this.ruleForm.rechargeInfo || '',
                //     rechargeType:this.ruleForm.rechargeType,
                //     subscript:this.ruleForm.subscript || '',
                //     subscriptColour:this.ruleForm.subscriptColour || '',
                //     templateInfo:this.ruleForm.templateInfo || '',
                //     bookId:this.ruleForm.bookId || '',
                // }
                // console.log(info)
                let json3 = {
                    appId: this.formInline.appId
                };
                let json4 = this.ruleForm;
                let paramJson1 = { ...json3, ...json4 }
                add(paramJson1).then(response => {
                    if (response.data.head.flag === 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.getTableData()
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })


            },
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 }
                console.log('paramJson', paramJson)
                list(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });

            },
            // 获取数据列表
            getSinaTemplateList () {
                listSign({
                    delFlag: 0
                }).then((response) => {
                    this.optionsSignType = response.data.content
                })
            },
            changeType (val) {
                console.log(val)
                this.ruleForm.rechargeType = val
				if (val == 1) {
                    this.ruleForm.signingType = 0
				}
            },
            changeSignType (val) {
                console.log(val)
                // this.ruleForm.sinaSigningTemplateId = obj.sinaSigningTemplateId
                // this.ruleForm.money = obj.money
                // this.ruleForm.nextMonthPrice = obj.nextMonthPrice
                // this.ruleForm.rechargeProject = obj.sinaSigningTemplateName
                // this.ruleForm.signingTemplateId = val
                this.getSinaTemplateInfo(val)
            },
            // 获取数据列表
            getSinaTemplateInfo(id) {
                detailsSign({
                    sinaSigningTemplateId: id,
                }).then((response) => {
                    this.ruleForm.signingTemplateId = response.data.content.sinaSigningTemplateId
                    this.ruleForm.money = response.data.content.money
                    this.ruleForm.nextMonthPric = response.data.content.nextMonthPrice
                    this.ruleForm.signingType = response.data.content.sinaSigningType
                    this.ruleForm.rechargeInfo = response.data.content.rechargeInfo
                })
            },
        }
    }
</script>
